// @ts-ignore - on the server we force this to become @sentry/node which confuses TypeScript
// TODO: This should not be imported from the API, we need to sort out a real solution for shared components
import * as Sentry from "@sentry/browser";
import { GraphQLFormattedError } from "graphql";
import React from "react";

import Alert from "../../../../../shared/components/design-system/Alert";
import sessionId from "../../global-furniture/session-id";

export declare interface GeneralError extends Error {
  graphQLErrors?: ReadonlyArray<GraphQLFormattedError>;
}

// Hint is a sentry type that we cannot import from Sentry
export type Hint = { [key: string]: object | string };

export function logToSentry(err: Error, hint?: Hint, force = false) {
  const error = err as GeneralError;
  return Sentry.captureException(error, hint);
}

export default function GenericError({ message, error }: { message?: string; error?: Error | null }) {
  if (!error) {
    return (
      <Alert variant="danger" className="ds-mb-7" message={message ?? "An error occurred whilst loading this data."} />
    );
  }

  const sentryErrorId = logToSentry(error);

  return (
    <Alert
      variant="danger"
      className="ds-mb-7"
      title={message ?? "An error occurred whilst loading this data."}
      message={`Please quote this error message if contacting support about this error: ${sentryErrorId ?? sessionId}`}
    />
  );
}
